const MARQUEE_SPEED = 24;

export const initServiceMarquees = () => {
  const marquees = document.querySelectorAll(".js-service-marquee");

  for (const marquee of marquees) {
    const viewport = marquee.querySelector(".js-service-marquee-viewport");
    const track = marquee.querySelector(".js-service-marquee-track");
    const sourceList = marquee.querySelector(".js-service-marquee-list");
    const toggle = marquee.querySelector(".js-service-marquee-toggle");

    if (!viewport || !track || !sourceList || !toggle) {
      continue;
    }

    const items = sourceList.querySelectorAll(".p-serviceMarquee__item");

    if (items.length < 2) {
      continue;
    }

    const reducedMotionQuery = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    );
    const clonedList = sourceList.cloneNode(true);
    let isUserPaused = false;
    let isHoverPaused = false;
    let isDocumentPaused = document.hidden;

    clonedList.classList.add("--clone");
    clonedList.setAttribute("aria-hidden", "true");
    track.append(clonedList);

    const updateDuration = () => {
      const sourceWidth = sourceList.getBoundingClientRect().width;
      const duration = Math.max(20, sourceWidth / MARQUEE_SPEED);

      marquee.style.setProperty("--service-marquee-duration", `${duration}s`);
    };

    const updateState = () => {
      const isReducedMotion = reducedMotionQuery.matches;
      const isPaused =
        isReducedMotion || isUserPaused || isHoverPaused || isDocumentPaused;

      marquee.classList.toggle("is-paused", isPaused);
      marquee.classList.toggle("is-reduced-motion", isReducedMotion);
      toggle.hidden = isReducedMotion;
      toggle.setAttribute("aria-pressed", String(isUserPaused));
      toggle.setAttribute(
        "aria-label",
        isUserPaused ? "自動スクロールを再開" : "自動スクロールを停止",
      );
    };

    marquee.addEventListener("mouseenter", () => {
      isHoverPaused = true;
      updateState();
    });

    marquee.addEventListener("mouseleave", () => {
      isHoverPaused = false;
      updateState();
    });

    toggle.addEventListener("click", () => {
      isUserPaused = !isUserPaused;
      updateState();
    });

    document.addEventListener("visibilitychange", () => {
      isDocumentPaused = document.hidden;
      updateState();
    });

    reducedMotionQuery.addEventListener("change", () => {
      isUserPaused = false;
      updateState();
    });

    if ("ResizeObserver" in window) {
      const resizeObserver = new ResizeObserver(updateDuration);
      resizeObserver.observe(sourceList);
    } else {
      window.addEventListener("resize", updateDuration);
    }

    updateDuration();
    updateState();
    marquee.classList.add("is-ready");
    toggle.hidden = reducedMotionQuery.matches;
  }
};
